import React, {useState} from 'react';
import { ASSETS_INDEX_WITH_COUNT } from './queries';
import { MainContainer, ContentContainer } from '../../elements';
import SubNav from './SubNav';
import DataTable from '@preflighttech/preflight-tables';
import { View, Text } from 'react-native';
import { Link } from 'app/src/utils/routing';
import IndexFilters, { SOLD_ON_FROM, SOLD_ON_TO } from './IndexFilters';
import { currency } from 'app/src/utils/stringHelpers';
import { dateShort } from 'app/src/utils/timeFormatter';

const ID_FILTERS = ['sellerId', 'buyerId'];
const SOLD_STATUS_FILTER = 'soldStatus';
const SEARCH_FILTER = 'search';
const SOLD_ON_FILTER = 'soldOn';

const Assets = props => {
  const { withNav } = props;

  const [refetch, setRefetch] = useState();
  const [filters, setFilters] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (!value) { return; }

    if (SEARCH_FILTER === key) {
      queryVariables.search = value;
    } else if (ID_FILTERS.includes(key)) {
      queryVariables[key] = value;
    } else if (SOLD_STATUS_FILTER === key) {
      queryVariables.scopes.push(value);
    } else if (SOLD_ON_FROM === key || SOLD_ON_TO === key) {
      // Combined into the soldOn range below once both ends are set.
    } else {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  if (filters[SOLD_ON_FROM] && filters[SOLD_ON_TO]) {
    queryVariables.filterColumns.push(SOLD_ON_FILTER);
    queryVariables.filterNames.push(
      [filters[SOLD_ON_FROM], filters[SOLD_ON_TO]]
    );
  }

  const columns = [
    {
      key: 'vin',
      label: 'VIN',
      sort: 'asc',
      content: (entry) => {
        return (
          <View>
            <Link to={`/sellers/${entry.entry.seller.id}/assets/${entry.entry.id}`}>
              {entry.entry.vin || 'Not Set'}
            </Link>
          </View>
        )
      }
    },
    {
      key: 'stockNumber',
      label: 'Stock #',
    },
    {
      key: 'year',
      label: 'Year',
    },
    {
      key: 'make',
      label: 'Make',
    },
    {
      key: 'model',
      label: 'Model',
    },
    {
      key: 'seller',
      label: 'Seller',
      content: entry => (
        <View>
          <Link to={`/sellers/${entry.entry.seller?.id}`}>
            {entry.entry.seller?.name}
          </Link>
        </View>
      ),
    },
    {
      key: 'miles',
      label: 'Miles',
    },
    {
      key: 'soldOn',
      label: 'Sold On',
      sort: 'prevent',
      content: dateShort,
    },
    {
      key: 'soldAmount',
      label: 'Sold Amount',
      content: entry => (
        entry.entry.soldAmount && currency(entry.entry.soldAmount)
      ),
    },
    {
      key: 'cachedTitleStatus',
      label: 'Title Status',
    },
    {
      key: 'inspectionCompleted',
      label: 'Inspection Complete',
      content: entry => entry.entry.inspectionCompleted ? 'Yes' : 'No',
    },
    {
      key: 'uccExpiresOn',
      label: 'Eligible Sale Date',
      content: dateShort,
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <Link
              to={`/sellers/${entry.entry.seller?.id}/assets/${entry.entry.id}`}
              style={{marginLeft: '10px'}}
            >
              View/Edit
            </Link>
          </View>
        )
      }
    }
  ]

  return (
    <MainContainer>
      {withNav &&
        <SubNav refetch={refetch} />
      }
      <ContentContainer>
        <Text><b>All Assets</b></Text>
        <IndexFilters
          filters={filters}
          setFilter={setFilter}
          onClear={() => setFilters({})}
        />
        <DataTable.Gql
          setRefetch={setRefetch}
          query={ASSETS_INDEX_WITH_COUNT}
          queryName='assetsWithCount'
          queryVariables={queryVariables}
          columns={columns}
          pageLength={25}
          lengthMenu={ [10, 25, 50, 'All'] }
          disableSearch
          htmlTable
        />
      </ContentContainer>
    </MainContainer>
  )
}

export default Assets;
